import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { switchMap } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { getAuth, getIdToken } from '@angular/fire/auth';
import { BehaviorSubject, Observable,from } from 'rxjs';


export interface DailyStats {
  day: string;
  unique_conversations: number;
}

export interface ConversationStats {
  conversation_id: string;
  documents_count: number;
  total_message_count: number;
}

export interface ConversationActivity {
  day: string;
  total_message_count: number;
}

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * 1️⃣ Get unique conversations per day (date range)
   * GET /analytics/daily?start=YYYY-MM-DD&end=YYYY-MM-DD
   */
  getDailyStats(startDate: string, endDate: string): Observable<DailyStats[]> {
  const params = new HttpParams()
    .set('start', startDate)
    .set('end', endDate);

  const auth = getAuth();
  const currentUser = auth.currentUser;

  if (!currentUser) {
    throw new Error('User not authenticated');
  }

  return from(getIdToken(currentUser, true)).pipe(
    switchMap((accessToken) => {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${accessToken}`,
        env: environment.prefix,
        uuid: currentUser.uid
      });

      return this.http.get<DailyStats[]>(
        `${this.baseUrl}${environment.endpoints.DAILY_CONVERSATIONS}`,
        { params, headers }
      );
    })
  );
}


  /**
   * 2️⃣ Get all conversations for a specific day
   * GET /analytics/conversations?day=YYYY-MM-DD
   */
  // getConversationsByDay(day: string): Observable<ConversationStats[]> {
  //   const params = new HttpParams().set('date', day);
  //   return this.http.get<ConversationStats[]>(`${this.baseUrl}${environment.endpoints.CONVERSATIONS}`, { params });
  // }
  getConversationsByDay(day: string): Observable<ConversationStats[]> {
  const params = new HttpParams().set('date', day);

  const auth = getAuth();
  const currentUser = auth.currentUser;

  if (!currentUser) {
    throw new Error('User not authenticated');
  }

  return from(getIdToken(currentUser, true)).pipe(
    switchMap((accessToken) => {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${accessToken}`,
        env: environment.prefix,
        uuid: currentUser.uid
      });

      return this.http.get<ConversationStats[]>(
        `${this.baseUrl}${environment.endpoints.CONVERSATIONS}`,
        { params, headers }
      );
    })
  );
}


  /**
   * 3️⃣ Get one conversation’s daily activity within a range
   * GET /analytics/conversation-activity?conversationId=ID&start=YYYY-MM-DD&end=YYYY-MM-DD
   */
  // getConversationActivity(
  //   conversationId: string,
  //   startDate: string,
  //   endDate: string
  // ): Observable<ConversationActivity[]> {
  //   const params = new HttpParams()
  //     .set('conversationId', conversationId)
  //     .set('start', startDate)
  //     .set('end', endDate);

  //   return this.http.get<ConversationActivity[]>(`${this.baseUrl}${environment.endpoints.CONVERSATION_ANALYTICS}`, { params });
  // }
  getConversationActivity(
  conversationId: string,
  startDate: string,
  endDate: string
): Observable<ConversationActivity[]> {
  const params = new HttpParams()
    .set('conversationId', conversationId)
    .set('start', startDate)
    .set('end', endDate);

  const auth = getAuth();
  const currentUser = auth.currentUser;

  if (!currentUser) {
    throw new Error('User not authenticated');
  }

  return from(getIdToken(currentUser, true)).pipe(
    switchMap((accessToken) => {
      const headers = new HttpHeaders({
        Authorization: `Bearer ${accessToken}`,
        env: environment.prefix,
        uuid: currentUser.uid
      });

      return this.http.get<ConversationActivity[]>(
        `${this.baseUrl}${environment.endpoints.CONVERSATION_ANALYTICS}`,
        { params, headers }
      );
    })
  );
}

}
